import React, { useState } from 'react';
import { UncontrolledPopover, PopoverBody } from 'reactstrap';
import styles from './IconTooltipWrapper.module.css';

const IconTooltipWrapper = ({ label, children }) => {
  // Create a unique ID for each tooltip instance to link the target and popover
  const [uniqueId] = useState(
    () => `tooltip-${Math.random().toString(36).substr(2, 9)}`
  );
  // Ensure there is only one child element to apply the tooltip to
  const child = React.Children.only(children);
  // Clone the child element to inject the unique ID as a prop
  const triggerElement = React.cloneElement(child, {
    id: uniqueId,
  });

  return (
    <>
      {triggerElement}
      <UncontrolledPopover
        placement='bottom'
        target={uniqueId}
        trigger='hover'
        fade={false}
        className={styles.popover}
        innerClassName={styles.tooltipBody}>
        <PopoverBody>{label}</PopoverBody>
      </UncontrolledPopover>
    </>
  );
};

export default IconTooltipWrapper;
